import { useEffect, useRef } from 'preact/hooks'
import { Field } from 'scripts/type'
import { SURVEY_ACTION_AREA_SELECTOR } from 'scripts/constants'

type Params = {
  isActivePage: boolean
  currentlyDisplayFields: Field[]
  pageElementHeightMap: Record<string, number>
  appendHeight?: number
  onFieldHeightChange?: (height: number) => void
  refreshDependence?: any[]
}

const useCalcPageHeight = ({
  isActivePage,
  currentlyDisplayFields,
  pageElementHeightMap,
  appendHeight = 0,
  refreshDependence = [],
  onFieldHeightChange,
}: Params) => {
  const prevHeight = useRef(0)
  useEffect(() => {
    // get the fresh pageElementHeightMap value in next tick
    setTimeout(() => {
      if (!Object.keys(pageElementHeightMap).length || !isActivePage) {
        return
      }
      const totalHeight =
        currentlyDisplayFields.reduce((memo, field) => {
          return memo + (pageElementHeightMap[field.code] ?? 0)
        }, 0) +
        (pageElementHeightMap[SURVEY_ACTION_AREA_SELECTOR] ?? 0) +
        appendHeight
      if (totalHeight > 0 && prevHeight.current !== totalHeight) {
        prevHeight.current = totalHeight
        onFieldHeightChange?.(totalHeight)
      }
    }, 0)
  }, [currentlyDisplayFields, isActivePage, ...refreshDependence])
}

export default useCalcPageHeight
